import React from 'react';
import PropTypes from 'prop-types';

import './ProductSearchUGCArticleCard.scss';

const ProductSearchUGCArticleCard = ({ article }) => {

	const { text, title } = article;

	return (
		<div className="ProductSearchUGCArticleCard">
			<h6 className="ProductSearchUGCArticleCard__title">
				{title}
			</h6>
			<div className="ProductSearchUGCArticleCard__text" dangerouslySetInnerHTML={{ __html: text }} />
		</div>
	);

};

ProductSearchUGCArticleCard.propTypes = {
	article: PropTypes.shape({
		text: PropTypes.string.isRequired,
		title: PropTypes.string
	})
};

export default ProductSearchUGCArticleCard;
